import { jsx as _jsx } from "react/jsx-runtime";
import * as Utils from '_utils';
import { LoadingPage } from './../app/LoadingPage';
import * as React from 'react';
export const UserContext = React.createContext({
    ...getPublicUser(),
    setUser: () => { },
});
UserContext.displayName = 'UserContext';
export function UserProvider(props) {
    const [state, setState] = React.useState(getPublicUser());
    React.useEffect(() => {
        // try to load user info at startup
        InitUserData(state)
            .then(user => {
            setState(user);
        })
            .catch();
    }, []);
    Utils.useTimer(1000 * 60 * 5, refreshUserInfo);
    async function refreshUserInfo() {
        if (state.isPublic) {
            // user was not authenticated, skip this
            return;
        }
        console.info('Updating user info.');
        let currentUserInfo = await LoadUserInfo();
        if (currentUserInfo.isPublic) {
            console.info('User session was terminated. Trying automatic refresh.');
            await TryAutoLogin();
            currentUserInfo = await LoadUserInfo();
        }
        setState(currentUserInfo);
    }
    if (!userIsLoaded(state)) {
        // TODO return loading screen
        return _jsx(LoadingPage, { loadingState: "loading user info" });
    }
    return (_jsx(UserContext.Provider, { value: { ...state, setUser: setState }, children: props.children }));
}
function userIsLoaded(user) {
    if (user && user.lastUpdate) {
        return true;
    }
    return false;
}
export async function InitUserData(currentUser) {
    const lastUpdate = currentUser.lastUpdate;
    if (lastUpdate) {
        // user has last update info, so it was loaded from server
        const infoAge = new Date().getTime() - lastUpdate.getTime();
        const fiveMinutes = 1000 * 60 * 5;
        if (infoAge > fiveMinutes) {
            currentUser = await LoadUserInfo();
        }
        return currentUser;
    }
    // no user info, try to auto login
    await TryAutoLogin();
    // load complete user info after auto login
    return await LoadUserInfo();
}
export function useUser() {
    return React.useContext(UserContext);
}
export async function LoadUserInfo() {
    sessionStorage.clear();
    return DoLoadUserInfo();
}
async function DoLoadUserInfo() {
    try {
        const userInfo = (await Utils.Ajax.get('/api/auth/userInfo'));
        userInfo.lastUpdate = new Date();
        return userInfo;
    }
    catch {
        return getPublicUser();
    }
}
function getPublicUser() {
    return { isPublic: true, roles: [] };
}
export async function TryLogin(values) {
    await Utils.Ajax.post('/api/auth/login', values);
    if (navigator.credentials) {
        const credentials = new PasswordCredential({
            id: values.login,
            type: 'password',
            password: values.password,
        });
        await navigator.credentials.store(credentials);
        console.info('Credentials stored for user ' + values.login);
    }
    return await LoadUserInfo();
}
export async function Logout() {
    await Utils.Ajax.post('/api/auth/logout');
    if (navigator.credentials) {
        await navigator.credentials.preventSilentAccess();
    }
    return await LoadUserInfo();
}
async function TryAutoLogin() {
    if (navigator.credentials && window.PasswordCredential) {
        const cred = await getCredentialsPromise();
        window.credentialPromise = undefined;
        if (cred) {
            try {
                await Utils.Ajax.post('/api/auth/login', {
                    login: cred.id,
                    password: cred.password,
                });
                console.info('Autologin successful for user ' + cred.id);
            }
            catch {
                console.warn('Autologin failed.');
            }
        }
    }
}
function getCredentialsPromise() {
    // this is here to deal with react strict mode, browser does not like this request to be fired twice
    if (!window.credentialPromise) {
        window.credentialPromise = navigator.credentials.get({
            password: true,
            unmediated: true,
        });
    }
    return window.credentialPromise;
}
